export default class ArrayUtils {
    public static unique<T>(list: T[]): T[] {
        return [...new Set(list)];
    }

    public static previousItem<T>(list: T[], item: T): T | null {
        const previousIndex = list.indexOf(item) - 1;
        return previousIndex < 0 ? null : list[previousIndex];
    }

    public static nextItem<T>(list: T[], item: T): T | null {
        const nextIndex = list.indexOf(item) + 1;
        return nextIndex >= list.length ? null : list[nextIndex];
    }

    public static getLastItem<T>(list: T[]): T | null {
        return list.length > 0 ? list[list.length - 1] : null;
    }

    static compareByKey<T>(key: keyof T | string, direction: 'ASC' | 'DESC') {
        const isDirectionDesc = direction == 'DESC';
        return function (a: T, b: T) {
            if (!Object.prototype.hasOwnProperty.call(a, key) || !Object.prototype.hasOwnProperty.call(b, key)) {
                return 0;
            }
            // @ts-ignore
            const rawA = a[key];
            // @ts-ignore
            const rawB = b[key];
            const varA = (typeof rawA === 'string') ? rawA.toUpperCase() : rawA;
            const varB = (typeof rawB === 'string') ? rawB.toUpperCase() : rawB;

            let comparison = 0;
            if (varA > varB) {
                comparison = 1;
            } else if (varA < varB) {
                comparison = -1;
            }
            return (
                isDirectionDesc ? (comparison * -1) : comparison
            );
        };
    }

     public static sortByKey<T>(list: T[], key: keyof T | string, direction: 'ASC' | 'DESC' = 'ASC'): T[] {
        return list.sort(ArrayUtils.compareByKey(key, direction));
    }
}